





























































import { Component, Vue } from "vue-property-decorator";
import memberCard from "@/components/home/MemberCard.vue";

@Component({ components: { memberCard } })
export default class About extends Vue {
  get content() {
    return this.$store.getters.getAboutContent;
  }

  get chairman() {
    return this.$store.getters.getChairman;
  }

  get honoraryChairman() {
    return this.$store.getters.getHonoraryChairman;
  }

  get coChairman() {
    return this.$store.getters.getCoChairman;
  }

  get mainOrganizer() {
    return this.$store.getters.getMainOrganizer;
  }

  get loaded() {
    return typeof this.content != "undefined";
  }
}
